import type { ItemType } from '~/components/common/SelectCheckbox';
import type { PortfolioDetail } from '~/data/generated/model';

export const getPortfoliosItems = (propertiesFromApi: PortfolioDetail[]): ItemType[] => {
  return propertiesFromApi.map(({ id, name }) => ({ id, label: name }));
};
